import React from 'react'

const BadLeadList = () => {
	return <div>BadLeadList</div>
}

export default BadLeadList
